export default __webpack_public_path__ + "static/media/shop-background-square-min.e3213fd7.jpg";